import c from 'classnames';
import { Icon, Typography } from '#components';

import styles from './BackButton.module.css';

export type BackButtonVariants = 'button' | 'link';
export const BackButton = ({
  variant = 'button',
  goBack,
}: {
  variant?: BackButtonVariants;
  goBack?: () => void;
}) => {
  return (
    <div
      className={c(
        styles.back,
        variant === 'button' && styles.button,
        variant === 'link' && styles.link,
      )}
      onClick={goBack}
    >
      <Icon name='chevronBack' size='s' />
      {variant === 'link' && (
        <Typography variant='body-s' className='my-auto'>
          Back
        </Typography>
      )}
    </div>
  );
};
